import { api } from '../services/api.js';

export function initContactForm() {
  const form = document.querySelector('[data-contact-form]');
  const status = document.querySelector('[data-form-status]');

  if (!form || !(form instanceof HTMLFormElement)) return;

  const setStatus = (message) => {
    if (!status) return;
    status.textContent = message;
  };

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const data = new FormData(form);
    const payload = {
      name: String(data.get('name') || ''),
      email: String(data.get('email') || ''),
      message: String(data.get('message') || ''),
    };

    if (!payload.name || !payload.email || !payload.message) {
      setStatus('Please fill out all fields.');
      return;
    }

    setStatus('Sending…');

    try {
      await api.submitContact(payload);
      form.reset();
      setStatus('Thanks — your message was sent.');
    } catch (err) {
      setStatus('Could not send right now. Please email Info@fuseio.co directly.');
    }
  });
}
